import { gql } from "@apollo/client";

export const GET_RADIODENSITY_MEASUREMENTS_BY_IDS = gql`
  query RadiodensityMeasurementsByIds($ids: [ID!]!) {
    radiodensityMeasurementsByIds(ids: $ids) {
      _id
      digital_twin_id
      vertebra
      height
      diameter
      mean
      min
      max
    }
  }
`;

export const GET_RADIODENSITY_MEASUREMENTS_BY_DIGITAL_TWIN_ID = gql`
  query RadiodensityMeasurementsByDigitalTwinId($digital_twin_id: ID!) {
    radiodensityMeasurementsByDigitalTwinId(digital_twin_id: $digital_twin_id) {
      _id
      digital_twin_id
      vertebra
      height
      diameter
      mean
      min
      max
    }
  }
`;
